import { env as runtimeEnv } from 'next-runtime-env';

const env = (key: string) => runtimeEnv(key) as string;

export const SETTINGS = {
  public: {
    basePath: env('NEXT_PUBLIC_BASE_PATH'),
    tmsToken: env('NEXT_PUBLIC_TMS_TOKEN'),
    geocodingApiKey: env('NEXT_PUBLIC_GEOCODING_API_KEY'),
    urlPartnerSvc: env('NEXT_PUBLIC_URL_CLUBE_PARTNER_SVC'),
    urlPartnerWeb: env('NEXT_PUBLIC_URL_CLUBE_PARTNER_WEB'),
    urlClubeParcerias: env('NEXT_PUBLIC_URL_CLUBE_PARCERIAS'),
    urlPublicationSvc: env('NEXT_PUBLIC_URL_CLUBE_PUBLICATION_SVC'),
    urlAdminSvc: env('NEXT_PUBLIC_URL_CLUBE_ADMIN_SVC'),
    urlAdminWeb: env('NEXT_PUBLIC_URL_CLUBE_ADMIN_WEB'),
    urlUserSvc: env('NEXT_PUBLIC_URL_USER_SVC'),
    urlAccountSvc: env('NEXT_PUBLIC_URL_ACCOUNT_SVC'),
    urlAccountWeb: env('NEXT_PUBLIC_URL_ACCOUNT_WEB'),
    urlHubWeb: env('NEXT_PUBLIC_URL_HUB_WEB'),
    urlAuthWeb: env('NEXT_PUBLIC_URL_AUTH_WEB'),
    urlRoleSvc: env('NEXT_PUBLIC_URL_ROLE_SVC'),
    pathPublicationWeb: env('NEXT_PUBLIC_PATH_CLUBE_PUBLICATION_WEB'),
    pathPartnerWeb: env('NEXT_PUBLIC_PATH_CLUBE_PARTNER_WEB'),
    pathAdminWeb: env('NEXT_PUBLIC_PATH_CLUBE_ADMIN_WEB'),
    pathHubWeb: env('NEXT_PUBLIC_PATH_HUB_WEB'),
    urlPlanWeb: env('NEXT_PUBLIC_URL_PLAN_WEB'),
    urlContractLegacySvc: env('NEXT_PUBLIC_URL_CONTRACT_LEGACY_SVC'),
    urlPublicationWeb: env('NEXT_PUBLIC_URL_CLUBE_PUBLICATION_WEB'),
    urlSystemEventSvc: env('NEXT_PUBLIC_URL_SYSTEM_EVENT_SVC'),
  },
  server: {
    basePath: env('BASE_PATH'),
  },
};
